<template>
  <div class="editor-roadmap">
    <div class="editor-roadmap__controls">
      <i-button type="primary" @click="addEmptyStage"> Добавить этап </i-button>
    </div>
    <div class="editor-roadmap__table">
      <i-table
        no-data-text="Этапы отсутствуют"
        border
        :data="filteredRoadmaps"
        :columns="columns"
        :disabled-hover="true"
        show-summary
        :summary-method="handleSummary"
      >
        <template slot-scope="{ row, index }" slot="number">
          <i-input
            :disabled="row.is_retention"
            type="text"
            v-model="row.number"
            @on-change="setData(index, 'number', $event)"
          />
        </template>
        <template slot-scope="{ row, index }" slot="name">
          <i-input
            :disabled="row.is_retention"
            type="text"
            v-model="row.name"
            @on-change="setData(index, 'name', $event)"
          />
        </template>
        <template slot-scope="{ row, index }" slot="parent_roadmap">
          <i-select
            :disabled="row.is_retention"
            v-model="row.parent_roadmap_id"
            placeholder="Выберите этап"
            @on-change="setData(index, 'parent_roadmap_id', $event)"
          >
            <i-option
              v-for="item in mainRoadmap"
              :value="item.id"
              :key="item.id"
              :label="`${item.number}. ${item.name}`"
            >
              {{ `${item.number}. ${item.name}` }}
            </i-option>
          </i-select>
        </template>
        <template slot-scope="{ row, index }" slot="start_date">
          <date-picker
            :disabled="row.is_retention"
            :class="isDatesNotValid(row) ? 'error-stage' : ''"
            @on-change="setData(index, 'start_date', $event)"
            placeholder="Выберите дату"
            v-model="row.start_date"
            format="dd.MM.yyyy"
          />
        </template>
        <template slot-scope="{ row, index }" slot="end_date">
          <date-picker
            :disabled="row.is_retention"
            :class="isDatesNotValid(row) ? 'error-stage' : ''"
            @on-change="setData(index, 'end_date', $event)"
            placeholder="Выберите дату"
            v-model="row.end_date"
            format="dd.MM.yyyy"
          />
        </template>
        <template slot-scope="{ row, index }" slot="costs">
          <input-number
            :disabled="row.is_retention"
            @on-change="setData(index, 'costs', $event)"
            v-model="row.costs"
            :min="0"
            :formatter="costsFormatter"
            :parser="costsParser"
          />
        </template>
        <template slot-scope="{ row, index }" slot="expert">
          <checkbox
            @on-change="toggleExpert($event, index)"
            v-model="row.is_expert"
          />
        </template>
        <template slot-scope="{ row, index }" slot="actions">
          <i-button
            v-if="!row.is_retention"
            shape="circle"
            icon="md-trash"
            type="text"
            @click="remove(index)"
          />
        </template>
      </i-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { costsConfig } from '@/config/costs'
import {
  isDatesNotValid,
  getSummaryRow,
  costsFormatter,
  costsParser
} from '@/utils'

const getColumns = (comp) => {
  let with_vat

  if (comp.editing) with_vat = comp.$store.state.contracts.current.with_vat
  else with_vat = comp.contract.with_vat

  const columns = [
    { title: '№', slot: 'number', key: 'number', width: 60 },
    { title: 'Наименование', slot: 'name', key: 'name' },
    {
      title: 'Этап основного договора',
      slot: 'parent_roadmap',
      width: 220
    },
    { title: 'Начало', slot: 'start_date', width: 128, key: 'start_date' },
    { title: 'Окончание', slot: 'end_date', width: 128, key: 'end_date' },
    {
      title: with_vat ? 'Сумма с НДС, руб.' : 'Сумма без НДС, руб.',
      slot: 'costs',
      key: 'costs',
      width: 120
    },
    {
      title: 'ГЭ',
      slot: 'expert',
      width: 60,
      key: 'is_expert'
    },
    { title: '', slot: 'actions', key: 'actions', width: 60, align: 'center' }
  ]

  return comp.$route.query.contract_id ||
    comp.$store.state.contracts.current.parent_id
    ? columns
    : columns.filter((c) => c.slot !== 'parent_roadmap')
}

export default {
  props: ['contract', 'editing'],
  data () {
    return {
      data: [],
      columns: getColumns(this),
      mainRoadmap: [],
      contract_id:
        this.$route.query.contract_id ||
        this.$store.state.contracts.current.parent_id,
      costsConfig
    }
  },
  computed: {
    filteredRoadmaps () {
      return this.contract.roadmaps.filter((r) => !r.disabled)
    }
  },
  methods: {
    async getMainRoadmap () {
      try {
        const roadmaps = await this.$store.dispatch('GET_REQUEST', {
          url: `page/roadmap?contract_id=${this.contract_id}`
        })

        this.mainRoadmap = roadmaps.filter((r) => r.id)
      } catch (error) {
        console.log(error)
      }
    },
    setData (index, name, e) {
      let value

      switch (name) {
        case 'name':
        case 'number':
          value = e.target.value
          break
        default:
          value = e
      }

      this.contract.roadmaps[index][name] = value
    },
    remove (index) {
      const { id } = this.contract.roadmaps[index]

      if (!id) this.contract.roadmaps.splice(index, 1)
      else this.$set(this.contract.roadmaps[index], 'disabled', true)
    },
    addEmptyStage () {
      const { roadmaps, start_date } = this.contract
      const item = {
        number: '',
        name: '',
        start_date: moment(start_date).format('DD.MM.YYYY') || '',
        end_date: '',
        costs: 0,
        is_expert: false,
        prepaid_value: 0,
        retention_value: 0,
        parent_roadmap_id: ''
      }

      roadmaps.push(item)
    },
    toggleExpert (value, index) {
      this.contract.roadmaps.forEach((r, i) => {
        if (i === index) {
          this.$set(r, 'is_expert', value)
        } else {
          this.$set(r, 'is_expert', false)
        }
      })
    },
    handleSummary (payload) {
      const col = this.contract_id ? [5] : [4]
      return getSummaryRow(payload, col)
    },
    isDatesNotValid,
    costsFormatter,
    costsParser
  },
  created () {
    if (this.contract_id) this.getMainRoadmap()
  }
}
</script>

<style lang="less">
.editor-roadmap {
  &__controls {
    margin-bottom: 8px;
    display: flex;
    justify-content: flex-end;
  }

  &__table {
    th .ivu-table-cell {
      word-break: break-word;
      text-align: center;
    }

    tbody {
      td {
        padding: 0;
        height: 28px;
      }
      .ivu-table-cell {
        padding: 0;
        width: 100%;

        &-slot {
          width: 100%;
          display: flex;
          justify-content: center;
        }

        .ivu-select-selection {
          border: none;
          border-radius: 0;
          background: transparent;
        }

        .ivu-input {
          border: none;

          &[disabled] {
            background-color: transparent;
          }

          &:focus {
            box-shadow: none !important;
          }
        }

        .ivu-input-number {
          width: 100%;
          border: none;

          &-handler-wrap {
            display: none;
          }
        }

        .ivu-checkbox-wrapper {
          margin: 0;
        }

        .ivu-btn-small {
          width: 20px;
          height: 20px;
          font-size: 12px;
          color: @danger-color;

          &.ivu-btn-text:hover,
          &.ivu-btn-text:focus {
            background: rgba(@danger-color, 0.1);
            color: @danger-color;
          }
        }
      }

      .error-stage .ivu-date-picker-editor {
        border: 1px solid @danger-color;
        border-radius: 4px;
      }
    }

    .ivu-table-summary {
      .ivu-table-cell {
        padding: 0 8px;
        font-weight: bold;
      }
    }
  }
}
</style>
